import { Box, SearchField } from '@factorialco/deprecated-design-system'
import { WorkSchedulesContainerDocument } from 'generated/resources/graphql'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PaginatedSchedulesList from 'modules/work_schedules/components/PaginatedSchedulesList'

const ArchivedWorkSchedulesPage = () => {
  const { debouncedSearch, search, onSearch } = useDebouncedSearch()
  const { nodes, loading, error, controls } = usePaginatedQuery(WorkSchedulesContainerDocument, {
    extractConnection: (data) => data?.workSchedule.schedulesConnection,
    variables: { onlyArchived: true, searchByName: debouncedSearch },
  })
  const schedules = nodes || []

  const { loading: contractVersionsLoading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return (
    <ResponsivePage.Body
      showHeader={false}
      error={error}
      loading={loading || contractVersionsLoading}
    >
      <Box gap="s16" alignItems="flexEnd">
        <Box width="fit-content">
          <SearchField
            placeholder={i18n.t('shift_management.rotating_shifts.search_by_name')}
            onSearch={onSearch}
            search={search}
            variant="regular"
          />
        </Box>
        <PaginatedSchedulesList
          schedules={schedules}
          controls={controls}
          archived
          contractVersions={contractVersions}
        />
      </Box>
    </ResponsivePage.Body>
  )
}

export default ArchivedWorkSchedulesPage
